import { render, staticRenderFns } from "./recentlyTask.vue?vue&type=template&id=c3a8a5be&scoped=true&"
import script from "./recentlyTask.vue?vue&type=script&lang=js&"
export * from "./recentlyTask.vue?vue&type=script&lang=js&"
import style0 from "./recentlyTask.vue?vue&type=style&index=0&id=c3a8a5be&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a8a5be",
  null
  
)

export default component.exports